import EquifaxReport from "../../../jsx/components/Dashboard/EquifaxReport/EquifaxReport";

const EquifaxReportsWrapper = () => {
  return <EquifaxReport />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];
export default constore(EquifaxReportsWrapper);
